import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getMspNotificationSettings,
  getMspResourceNotificationSettings,
  getMspUserNotificationSettings,
  updateMspNotificationSettings,
  updateMspResourceNotificationSettings,
  updateMspUserNotificationSettings,
} from "controller/api";
import {
  UpdateMspNotificationInput,
  UpdateMspNotificationInputOld,
} from "shared";
import { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";

export const useGetMspNotificationSettings = () => {
  return useQuery({
    queryKey: ["msp_notification_settings"],
    queryFn: () => getMspNotificationSettings(),
    onError: (error) => console.log(error),
  });
};

export const useUpdateMspNotificationSettings = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (value: UpdateMspNotificationInputOld) =>
      updateMspNotificationSettings(value),
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(["msp_notification_settings"]);
      },
    }
  );
};

export const useGetMspResourceNotificationSettings = () => {
  return useQuery({
    queryKey: ["msp_notification_settings"],
    queryFn: () => getMspResourceNotificationSettings(),
    onError(error: ApiErrorType) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getMspResourceNotificationSettings",
      });
    },
  });
};

export const useGetMspUserNotificationSettings = () => {
  return useQuery({
    queryKey: ["msp_user_notification_settings"],
    queryFn: () => getMspUserNotificationSettings(),
    onError(error: ApiErrorType) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getMspUserNotificationSettings",
      });
    },
  });
};

export const useUpdateMspResourceNotificationSettings = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (value: UpdateMspNotificationInput) =>
      updateMspResourceNotificationSettings(value),
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(["msp_notification_settings"]);
      },
      onError(error: ApiErrorType) {
        sentryLogger({
          error: error,
          workflow: "controlCenter",
          level: "error",
          functionName: "updateMspResourceNotificationSettings",
        });
      },
    }
  );
};

export const useUpdateMspUserNotificationSettings = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (value: UpdateMspNotificationInput) =>
      updateMspUserNotificationSettings(value),
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(["msp_user_notification_settings"]);
      },
      onError(error: ApiErrorType) {
        sentryLogger({
          error: error,
          workflow: "controlCenter",
          level: "error",
          functionName: "updateMspUserNotificationSettings",
        });
      },
    }
  );
};
